<nav class="usa-breadcrumb" aria-label="Breadcrumbs,,">
  <ol class="usa-breadcrumb__list">
    @for (breadcrumb of breadCrumbs$ | async; track breadcrumb) {
      <li class="usa-breadcrumb__list-item">
        @if (breadcrumb.isActive === true) {
          <a class="usa-breadcrumb__link">
            <span>{{breadcrumb.title}}</span></a>
          }
          @if (breadcrumb.isActive === false) {
            <a [routerLink]="['/' + breadcrumb.url]" [queryParams]="breadcrumb.params" class="usa-breadcrumb__link">
              <span>{{breadcrumb.title}}</span>
            </a>
          }
        </li>
      }
      <!--<li class="usa-breadcrumb__list-item usa-current" aria-current="page">
      <span>Women-owned small business federal contracting program</span>
    </li>-->
  </ol>
</nav>
